<template>
    <v-dialog v-model="getModalCadastroGrupoProduto" max-width="500px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Cadastro de Grupo</v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-text-field outlined dense outlined v-model="getGrupoProduto.grupo" label="Grupo"
                            class="ml-2 mr-2" @keyup.13="salvar" :rules="rules.grupo"></v-text-field>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroGrupoProduto(false)">Voltar</v-btn>
                    <v-btn outlined color="error" @click="excluirGrupoProduto(getGrupoProduto.id)"
                        v-if="getGrupoProduto.id">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {

        data() {
            return {
                rules: {
                    grupo: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                }
            }

        },
        computed: {
            ...mapGetters([
                'getModalCadastroGrupoProduto',
                'getGrupoProduto'
            ])
        },
        methods: {
            ...mapActions([
                'cadastrarGrupoProduto',
                'salvarGrupoProduto',
                'atualizarGrupoProduto',
                'excluirGrupoProduto',
                'setModalCadastroGrupoProduto'
            ]),
            salvar() {
                console.log(this.$refs.form)
                if(this.$refs.form.validate()){
                    if (this.getGrupoProduto.id) {
                        this.atualizarGrupoProduto(this.getGrupoProduto)
                    } else {
                        this.salvarGrupoProduto(this.getGrupoProduto)
                    }
                }
            }
        },

    }
</script>